<div class="noResults">
  <div class="searchResultsPresent">
    <div *ngIf="!resultPresent">
      <a (click)="redirectToHelpCenter()" class="help-link">
        View all Help Topics
      </a>
    </div>
  </div>
</div>
